import React from "react";
import HomeHero from "../homeScreens/HomeHero";
import FeaturedIn from "../homeScreens/FeaturedIn";
import AboutUs from "../homeScreens/AboutUs";
import ServicesAlbum from "../homeScreens/ServicesAlbum";
import HowItWorks from "../homeScreens/HowItWorks";
import WhyChooseUs from "../homeScreens/WhyChooseUs";
import TestimonialsCarousel from "../homeScreens/TestimonialsCarousel";
import ServiceProviderJoin from "../homeScreens/ServiceProviderJoin";
import FAQs from "../homeScreens/FAQs";
import ContactUs from "../homeScreens/ContactUs";
import GetStartedBanner from "../homeScreens/GetStartedBanner";
import LatestBlogTitles from "../blog/LatestBlogTitles";
import img from "./bg.svg";

export const HomePage = () => {
  return (
    <div className="relative md:mt-0 mt-24">
      {/* Sections with side padding */}
      <div className="px-4 lg:px-20">
        <HomeHero />
        <FeaturedIn />
      </div>

      {/* Section with Background Image (no side padding) */}
      <div className="relative z-0 overflow-x-hidden">
        <img
          src={img}
          alt="Background"
          className="absolute top-0 -left-0 w-full h-full object-cover z-[-1]"
        />
        <div className="px-4 lg:px-20">
          <AboutUs />
          <ServicesAlbum />
        </div>
      </div>

      {/* Rest of the sections with side padding */}
      <div className="px-4 lg:px-20">
        <HowItWorks />
        <WhyChooseUs />
      </div>
      <TestimonialsCarousel />
      <div className="px-4 lg:px-20">
        <LatestBlogTitles />
        <ServiceProviderJoin />
        <FAQs />
        <ContactUs />
        <GetStartedBanner />
      </div>
    </div>
  );
};
